/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Fix log settings change request
 */
export interface FixLogSettingChangeRequest {
  id: number;
  logIncoming: boolean;
  logOutgoing: boolean;
  logIntoOneFile: boolean;
  logHeartbeats: boolean;
}
